import { ICON_TYPES } from './iconTypes';

export default {
	create: {
		name: 'create',
		type: ICON_TYPES.ionicon,
		text: 'New',
	},
	edit: {
		name: 'pencil',
		type: ICON_TYPES.ionicon,
		text: 'Edit',
	},
	save: {
		name: 'checkmark-circle',
		type: ICON_TYPES.ionicon,
		text: 'Save',
	},
	upload: {
		name: 'file-upload-outline',
		type: ICON_TYPES.materialCommunityIcons,
		text: 'Upload',
	},
	videoUpload: {
		name: 'file-video',
		type: ICON_TYPES.fontAwesome5,
		text: 'Video'
	},
	delete: {
		name: 'trash',
		type: ICON_TYPES.fontAwesome,
		text: 'Delete',
	},
	archive: {
		name: 'archive-remove',
		type: ICON_TYPES.materialCommunityIcons,
		text: 'Archive',
	},
	add: {
		name: 'add-circle-outline',
		type: ICON_TYPES.ionicon,
		text: 'New',
	},
	remove: {
		name: 'remove',
		type: ICON_TYPES.fontAwesome,
		text: 'Remove',
	},
	removeCircle: {
		name: 'remove-circle-outline',
		type: ICON_TYPES.ionicon,
		text: 'Remove',
	}

};